export enum AuthLinkLabelsDisplayEnum {
  LOGIN = "login",
  SIGNUP = "signup"
}